import {createAction} from 'redux-act';
import {AxiosPromise} from 'axios';

import {ENDPOINTS} from 'constants/endpoints';
import {instanceGusaBackend} from 'libs/api';

export const switchCart = createAction('SWITCH_CART');
export const moveAllItemsToShoppingCart = createAction<AxiosPromise>(
    'MOVE_ALL_ITEMS_T0_SHOPPING_CART',
    () =>
        instanceGusaBackend({
            method: 'PUT',
            url: `${ENDPOINTS.CART_V2}`,
            data: {hto: false},
        }),
);
